import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser'
import { ApiResult, LoginService, MasterService, NavDropdownItem, UsuarioToken, TemaService } from 'ui-shared';
import { masterConfiguracao, masterOperacao, masterSemContaEmUso } from './master-config';
import { Subscription, forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Rules } from './features/compartilhado/roles-guard/rules';
import { ConfiguracaoDataService } from './services/data-services/configuracao.data.service';
import { ContaEmUsoService } from './services/conta-em-uso/conta-em-uso.service';
import { ConfiguracaoEntity } from '@catalogo/models';
import { environment } from "@env/environment";
import { EnumAmbiente } from "@env/enum-ambiente";
import { ParametroValorEntity } from "@catalogo/models";
import { ParametroValorOperacaoDataService } from "@catalogo/services/data-services";

@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    token: UsuarioToken;
    subscriptions: Subscription[] = [];
    private contasCarregadas: boolean = false;
    private contasCache: { itens: NavDropdownItem[]; selecionada: NavDropdownItem | null } | null = null;
    private redirecionandoRaiz = false;

    constructor(
        private router: Router,
        private loginService: LoginService,
        private masterService: MasterService,
        private contaEmUsoService: ContaEmUsoService,
        private configuracaoDataService: ConfiguracaoDataService,
        private parametroValorDataService: ParametroValorOperacaoDataService,
        private ngZone: NgZone,
        private title: Title,
        private rules: Rules,
        private temaService: TemaService
    ) {
        this.temaService.inicializar();
        this.title.setTitle('Catálogo de Produtos')
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach(x => x.unsubscribe());
    }

    private carregarContasEmUso(): void {
        if (!this.masterService.multiConta || !this.masterService.modulo) {
            return;
        }
        // masterService.update() substitui a configuração e apaga os itens do dropdown.
        // Se as contas já foram carregadas, reaplica-as em vez de ignorar a chamada.
        if (this.contasCarregadas) {
            if (this.contasCache) {
                this.masterService.atualizarItensDropdown(this.contasCache.itens, this.contasCache.selecionada as NavDropdownItem);
            }
            return;
        }
        this.contasCarregadas = true;
        this.subscriptions.push(this.contaEmUsoService.obterItens(this.masterService.permicaoAmbiente, this.masterService.modulo)
            .subscribe(({ itens, selecionada }) => {
                this.contasCache = { itens, selecionada };
                this.masterService.atualizarItensDropdown(itens, selecionada as NavDropdownItem);
            }));
    }

    private redirecionarRaizParaHome(): void {
        if (this.redirecionandoRaiz) {
            return;
        }
        this.redirecionandoRaiz = true;
        this.subscriptions.push(this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd && event.url === '/') {
                this.router.navigateByUrl('/home');
            }
        }));
    }

    ngOnInit(): void {
        this.subscriptions.push(this.loginService.token$.subscribe(token => {
            if (token) {
                this.ngZone.run(() => {
                    if (token.contaEmUso) {
                        // Carrega ambiente, parâmetro e ícone juntos e faz um único update do master,
                        // para que nenhum update posterior apague as contas do dropdown.
                        this.subscriptions.push(forkJoin({
                            ambiente: this.configuracaoDataService.obterAmbiente(),
                            parametro: this.parametroValorDataService.obterPorCodigo('OPENAI_SANEAMENTO_SUGESTAO_PREENCHIMENTO').pipe(catchError(() => of(null))),
                            icone: this.configuracaoDataService.obterIconeDespachante().pipe(catchError(() => of(null)))
                        }).subscribe(({ ambiente: resAmbiente, parametro, icone }) => {
                            const data = (resAmbiente as ApiResult<ConfiguracaoEntity>).data;
                            const ambiente = data?.ambiente != "Produção" ? `Ambiente ${data?.ambiente}` : "";
                            const exibirAtributoParametro = (parametro as ApiResult<ParametroValorEntity> | null)?.data?.valor == "true";
                            const iconeDespachante = (icone as ApiResult<string> | null)?.data;

                            this.masterService.update(masterOperacao(this.rules, this.loginService.accessToken, ambiente, exibirAtributoParametro, iconeDespachante));
                            this.carregarContasEmUso();
                            this.redirecionarRaizParaHome();
                        }));
                    } else if (token.suporte) {
                        let ambiente = environment.ambiente != EnumAmbiente.Producao ? `Ambiente ${environment.ambiente}` : "";
                        this.masterService.update(masterConfiguracao(ambiente));
                        this.carregarContasEmUso();
                    } else {
                        this.masterService.update(masterSemContaEmUso);
                        this.carregarContasEmUso();
                    }
                });
            }
        }));
    }
}
